var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manufacturer"},[_c('img',{attrs:{"src":_vm.manufacturer.img,"alt":"厂家图片"}})])}
var staticRenderFns = []

export { render, staticRenderFns }